
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';

import {useTranslation} from 'react-i18next';
import { getData } from '../../helpers/indexedDbHelper';
import DetailProduct from './DetailProduct';
import CategoriesScreen from './categories';

function Index({dishs, setShowListProduct, setShowHappy}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const [menus, setMenus] = useState([]);
    const [dataFood, setDataFood] = useState(false);
    const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [dataDish, setDataDish] = useState(false); 
    const [grill, setGrill] = useState(false);
    const [ribeye, setRibeye] = useState(false);
     const [showCategories, setshowCategories] = useState(false);
    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
            setMenus(data);
        });
    }, []);
    

    useEffect(() => {
        menus.map((item) => {
            if (item.id === 257) {
                setDataFood(item.menus);
            }
        });
    }, [menus]);

    useEffect(() => {
        if (dataFood) {
            dataFood.map((item) => {
                if (item.id === 2811) {
                    setGrill(item);
                }
                if (item.id === 2385) {
                    setRibeye(item);
                }
            });
        }
    }, [dataFood]);
    
    
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent   showImageTop={false} showLamp={false} showBack={setShowHappy} setShowListProduct={setShowHappy} goHome={setShowHappy} goCategories={setshowCategories}>
                <div  style={{padding: '0 20px', height: 750,  overflow: 'scroll', marginTop: 50}}>
                    <div
                       >
                        <img
                            src={require('./assets/wine.png')}
                            style={{
                                marginTop: 10,
                                width: '100%',
                                height: 900,
                                objectFit: 'contain',
                                borderRadius: 20,
                            }}
                        />
                    </div>

                </div>

                {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}

                {showDetailProduct && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={setShowDetailProduct}
                    setShowDetailProduct={setShowDetailProduct}
                />}
            </LayoutContent>
        </div>
    );
}
export default Index;